/** @format */

import { Grid } from '@material-ui/core';
import { filesize } from 'filesize';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/button';
import { DeleteIcon, UploadIcon } from 'src/components/icons';
import { MAX_FILE_SIZE, MAX_FILE_SIZE_TEXT, MAX_NUMBER_OF_FILES } from 'src/constants';
import { useSelector } from 'src/store';
import { getFileBase64 } from 'src/utils/helper';

export const UploadField = ({ error, postData, setPostData, fileKey, setValidations }) => {
  const { t } = useTranslation();
  const { updateTicketLoading, error: errorTicket } = useSelector(state => state.tickets);
  const [files, setFiles] = useState([]);

  const filesValidation = useCallback(async fileArr => {
    let _validations = { attachments: null };
    if (fileArr.length > MAX_NUMBER_OF_FILES) {
      _validations = {
        attachments: t('personalData.profile_errors.maxFiles', { limit: MAX_NUMBER_OF_FILES })
      };
    } else {
      const totalSize = fileArr.reduce((acc, file) => acc + file.size, 0);
      const totalSizeMB = totalSize / (1024 * 1024);
      if (totalSizeMB > MAX_FILE_SIZE) {
        const sizePretty = filesize(totalSize);
        _validations = {
          attachments: t('personalData.profile_errors.maxSize', {
            fileSize: sizePretty,
            limit: `${MAX_FILE_SIZE_TEXT} MB`
          })
        };
      }
    }
    return _validations;
  }, []);

  const handleSelectFiles = async e => {
    const { target } = e;
    const _files = files.concat(Array.from(target.files));
    setFiles(_files);
    if (target.files && target.files.length > 0) {
      const fileArr = postData.attachments ? [...postData.attachments] : [];
      const fileNameArr = postData.attachmentFileNames ? [...postData.attachmentFileNames] : [];
      await Promise.all(
        Array.from(target.files).map(async file => {
          const fileContent = await getFileBase64(file);
          fileNameArr.push(file.name);
          fileArr.push(fileContent);
        })
      );
      const _postData = { ...postData, attachmentFileNames: fileNameArr, attachments: fileArr };
      setPostData(_postData);
      const _filesValidation = await filesValidation(_files);
      setValidations(validations => ({ ...validations, ..._filesValidation }));
    }
  };
  const removeFile = async index => {
    files.splice(index, 1);
    const _files = [...files];
    setFiles(_files);
    const fileArr = [];
    const fileNameArr = [];
    await Promise.all(
      Array.from(files).map(async file => {
        const fileContent = await getFileBase64(file);
        fileNameArr.push(file.name);
        fileArr.push(fileContent);
      })
    );
    const _postData = { ...postData, attachmentFileNames: fileNameArr, attachments: fileArr };
    setPostData(_postData);
    const _filesValidation = await filesValidation(_files);
    setValidations(validations => ({ ...validations, ..._filesValidation }));
  };

  return (
    <>
      {files.length < MAX_NUMBER_OF_FILES && (
        <Grid container>
          <Grid item xs={12}>
            <Grid style={{ marginBottom: 10 }}>
              <Button disabled={updateTicketLoading} noArrow borderOnly additionalClassName="visually-hidden-input">
                <label htmlFor="attachments">
                  <UploadIcon /> {t('Tickets.attachmentPlaceholder', { limit: `${MAX_FILE_SIZE_TEXT} MB` })}
                </label>
                <input
                  // accept="image/png, image/gif, image/jpeg, image/jpg"
                  id="attachments"
                  type="file"
                  multiple
                  onChange={handleSelectFiles}
                  key={fileKey}
                />
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
      {files.length > 0 && (
        <Grid container>
          <Grid item xs={12}>
            <Grid style={{ marginBottom: 10 }}>
              <h4>Selected file</h4>
              <div className="file-list">
                {files.map((file, fileIndex) => (
                  <div className="file-item" key={`${fileIndex}-${file.name}`}>
                    {file.name}
                    <button onClick={() => removeFile(fileIndex)} disabled={updateTicketLoading}>
                      <DeleteIcon />
                    </button>
                  </div>
                ))}
              </div>
            </Grid>
          </Grid>
        </Grid>
      )}
      {error && <p className="page_error">{error}</p>}
    </>
  );
};
